import React from "react"
import css from '../../NfpStyles'
import { Box, Divider, Grid2 as Grid, Typography } from '@mui/material'
import { getNamedNutrients, isSelected } from '../../NfpUtils'
import FrontOfPackage from './FrontOfPackage'

let css2 = {
  nutritionFactPanelSuppressed: {
    maxWidth: '442px',
    pageBreakInside: 'avoid',
    breakInside: 'avoid'
  },
  av: {
    marginLeft: '1em',
    minHeight: '13px',
    height: '1em'
  },
  bold: {
    fontWeight: 900
  },
  calories: {
    height: '3em'
  },
  caloriesH2: {
    position: 'absolute',
    bottom: 0,
    textAlign: 'right'
  },
  caloriesH3: {
    position: 'absolute', 
    bottom: 0,
    textAlign: 'left'
  },
  colXs6: {
    position: 'relative',
    minHeight: '1px',
    paddingRight: '15px',
    paddingLeft: '15px',
    float: 'left',
    width: '48%'
  },
  column1: {
    flexBasis: '100%',
    paddingLeft: 0
  },
  columnNutrientAv: {
    marginLeft: '0.5em',
    fontSize: '11px'
  },
  columnNutrientDv: {
    marginLeft: '0.5em',
    fontSize: '11px',
    float: 'none'
  },
  indent1: {
    padding: '.15em 0 .15em 15px',
  },
  indent1Child: {
    fontWeight: 'normal',
    marginTop: '.3em',
    lineHeight: '1.1em'
  },
  right: {
    textAlign: 'right'
  },
  dv: {
    float: 'right',
    minHeight: '13px',
    height: '1em'
  },
  h1: {
    fontSize: '14pt',
    lineHeight: 1.1,
    verticalAlign: 'bottom',
  },
  h2: {
    fontSize: '13pt',
    lineHeight: 1.1,
    verticalAlign: 'bottom',
  },
  h3: {
    fontSize: '12pt',
    lineHeight: 1.1,
    verticalAlign: 'bottom',
  },
  h4: {
    fontSize: '11pt',
    lineHeight: .9,
    marginTop: '.15em',
    marginBottom: '0',
    verticalAlign: 'bottom',
  },
  h5: {
    fontSize: '10pt',
    lineHeight: .9,
    verticalAlign: 'bottom',
  },
  h6: {
    fontSize: '7.5pt',
    verticalAlign: 'bottom',
  },
  h7: {
    fontSize: '7pt',
    lineHeight: .5,
    verticalAlign: 'bottom',
  },

  m003: {
    marginTop: '0px',
    marginRight: '0px',
    marginBottom: '3px',
    marginLeft: '0px'
  },
  normalFont: {
    fontWeight: 400
  },
  nutrientName: {
    whiteSpace: 'nowrap',
    fontSize: '11px'
  },
  row: {
    marginTop: '2px'
  },
  servingSize: {
    lineHeight: 1.3
  }
}

export default function NfpSuppressedView ({nfp = {}, lds = {}}) {
  const microNutrients = [...Object.keys(nfp)].reduce((microNutrients, id) => {
    let n = nfp[id]
    if(n.isMicroNutrient) {
      microNutrients.push(n)
    }
    return microNutrients
  }, [])

  const {  satFat, sodium,totalSugars
    } = getNamedNutrients(nfp)
    const hasFOP = (satFat?.percent >= 15 || totalSugars?.percent >= 15 || sodium?.percent >= 15)

  return (
    <Box>
      { hasFOP && <>
      <Typography>Front of Package: </Typography>
      <Box id="front-of-package-label" style={{ ...css.nutritionFactPanel, ...css2.nutritionFactPanelSuppressed }}>
          <Typography variant="h2" style={css.h2}> Front of Package Not Required</Typography>
      </Box>
      </>
      }

      <br/>

      <Box id="nutrition-fact-panel-suppressed" style={{ ...css.nutritionFactPanel, ...css2.nutritionFactPanelSuppressed }}>
        <Typography variant="h2" style={css.h2}>Nutrition Facts Not Required</Typography>
      </Box>
    </Box>
  )
}
